import { get, Chain } from '@web3/utils';

export type TokenListItem = {
  // 链ID
  chainId: number;
  // 币种ID
  tokenId: number;
  // 币种名称
  tokenName: string;
  // 币种地址
  address: string;
  // 图标
  icon: string;
  // 精度
  decimals: number;
  // 24小时价格
  price: string;
  // 24小时价格变化百分比
  priceChange: string;
  // 24小时交易量
  volume: string;
  // 是否被收藏
  favoriteFlag: boolean;
  // 流动性
  liquidity: string;
  // 标签列表
  tokenTags: string[];
};

export enum RankType {
  CHAIN = 'chain',
  FAVORITE = 'favorite',
}

export type QueryTokenListParams = {
  // 链ID，可选参数，如果不传则默认为 "ALL"
  chainId?: string;
  // 内容，可选参数，根据长度判断是token还是合约地址
  content?: string;
  // 标签，可选参数，预留字段，可以是 "hot" 或 "top"
  tag?: string;
  // 排序字段，可选参数，默认为 "token"
  orderBy?: 'token' | 'price' | 'volume' | 'change' | 'liquidity';
  // 排序方向，可选参数，默认为 "asc"
  direction?: 'asc' | 'desc';
  // 翻页起始的tokenid，可选参数
  from?: number;
  // 单次请求数量限制，可选参数，默认为50
  limit?: number;
  // 钱包id
  walletId?: string;
  // 收藏状态
  rankType?: RankType;
};

export const queryTokenList = (params: QueryTokenListParams) => {
  return get<TokenListItem[]>('/web3/api/quote/v1/token/suggest', {
    params,
  });
};

export enum SwapScene {
  //  Swap
  Swap = 'Swap',
  //  Dex pro
  DexPro = 'DexPro',
}

export type SwapChain = Chain & {
  defaultFromTokenAddress: string;
  defaultToTokenAddress: string;
  supportSceneConfig: Array<{
    defaultToTokenAddress: string;
    defaultToTokenSymbol: string;
    scene: SwapScene;
  }>;
};

// 獲取swap支援的chains
export const getSupportedChains = () => {
  return get<SwapChain[]>('/spot/api/web3/swap/v3/chains');
};
